import useFormSubmit from "@/hooks/useFormSubmit";

const FORM_ID = "dah99kjoh653ivfvnp10";
const SUBMIT_ADDR = "https://readdy.ai/api/form/dah99kjoh653ivfvnp10";

const inputClass =
  "h-11 px-3.5 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400";

export default function ContactForm() {
  const { status, message, handleSubmit } = useFormSubmit(
    SUBMIT_ADDR,
    "线索已收到，编辑会在 48 小时内核实并回复你。"
  );

  return (
    <form id={FORM_ID} data-readdy-form onSubmit={handleSubmit} noValidate className="flex flex-col gap-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <label className="flex flex-col gap-1.5">
          <span className="text-xs text-foreground-600">你的称呼</span>
          <input type="text" name="name" required placeholder="如何称呼你" className={inputClass} />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="text-xs text-foreground-600">联系方式邮箱</span>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="you@example.com"
            className={inputClass}
          />
        </label>
      </div>
      <label className="flex flex-col gap-1.5">
        <span className="text-xs text-foreground-600">线索类型</span>
        <select name="type" defaultValue="tip" className={`${inputClass} cursor-pointer`}>
          <option value="tip">投递新线索</option>
          <option value="update">补充时间线进展</option>
          <option value="correct">指出信息错误</option>
          <option value="cooperate">内容合作与转载</option>
        </select>
      </label>
      <label className="flex flex-col gap-1.5">
        <span className="text-xs text-foreground-600">线索说明（不超过 500 字）</span>
        <textarea
          name="message"
          required
          maxLength={500}
          rows={5}
          placeholder="请尽量写明事件时间、出处与可核查的原始材料，方便我们快速核实。"
          className="px-3.5 py-3 rounded-md bg-background-50 border border-background-300 text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 resize-none"
        />
      </label>
      <input
        type="text"
        name="contact_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-aux-note"
      />
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-11 px-6 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
        >
          {status === "loading" ? (
            <i className="ri-loader-4-line animate-spin" />
          ) : (
            <i className="ri-send-plane-line" />
          )}
          提交线索
        </button>
        {status === "success" ? (
          <p className="text-sm text-secondary-700 inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line" />
            {message}
          </p>
        ) : null}
        {status === "error" ? (
          <p className="text-sm text-primary-700 inline-flex items-center gap-1.5">
            <i className="ri-error-warning-line" />
            {message}
          </p>
        ) : null}
      </div>
    </form>
  );
}